import React from 'react';
import AuthenticationLogin from './requests/auth/AuthenticationLogin'

const Login = () => {
    return <AuthenticationLogin/>
}


export default Login;